// Messages store whether AI was paused when they were sent, so a pause or resume happened right before the first
// message that differs from the one above it.
export const didAiPauseChange = (
  wasAiSnoozed: boolean,
  isAiSnoozed: boolean | null | undefined,
) => Boolean(isAiSnoozed) !== wasAiSnoozed;
